import types from "./types";

const authReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case types.SET_USER: {
      return {
        ...state,
        currentUser: payload,
        loaded: true,
      };
    }
    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/state/auth/reducers.js